import http from "@/shared/services/http";

export const listNotYetPayManageFee = (params: any) =>  http.get(`v1/customer/manage-fee/list-not-yet-pay`,  { params });
export const listPayedManageFee = (params: any) =>  http.get(`v1/customer/manage-fee/list-payed`,  { params });
export const listDebtsDetailPayedManageFee = (params: any) =>  http.get(`v1/customer/manage-fee/detail-payed/debts`, { params });
